import { useState } from "react";
import { Copy, Check, Share2, Ticket } from "lucide-react";

interface InviteCodeShareProps {
  slug: string;
}

export default function InviteCodeShare({ slug }: InviteCodeShareProps) {
  const [copied, setCopied] = useState(false);

  const shareUrl = `${window.location.origin}/join/${slug}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback: select text for manual copy
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Join my scavenger hunt!",
          text: `Join my game on ISPYFR! Code: ${slug}`,
          url: shareUrl,
        });
      } catch {
        // User cancelled share
      }
    } else {
      handleCopy();
    }
  };

  return (
    <div className="rounded-2xl border border-border bg-surface-sunken p-5 text-center">
      <div className="flex items-center justify-center gap-1.5 text-sm font-medium uppercase tracking-wider text-text-secondary">
        <Ticket className="h-4 w-4" />
        Invite Code
      </div>
      <p className="mt-1 font-display text-3xl font-bold tracking-widest text-primary">
        {slug}
      </p>
      <div className="mt-4 flex justify-center gap-2">
        <button
          onClick={handleCopy}
          className="inline-flex items-center gap-1.5 rounded-xl bg-surface px-4 py-2 text-base font-medium text-text-secondary transition-colors hover:bg-surface-raised"
        >
          {copied ? <Check className="h-4 w-4 text-accent" /> : <Copy className="h-4 w-4" />}
          {copied ? "Copied!" : "Copy Link"}
        </button>
        {"share" in navigator && (
          <button
            onClick={handleShare}
            className="inline-flex items-center gap-1.5 rounded-xl bg-primary px-4 py-2 text-base font-medium text-text-inverse transition-colors hover:bg-primary-hover"
          >
            <Share2 className="h-4 w-4" />
            Share
          </button>
        )}
      </div>
    </div>
  );
}
